<template>
  <div class="page-wrap">
    <div class="session-form-hold">
      <base-card :loading="loading" v-if="!ticket">
        <v-card-text class="text-center">
          <img
            v-if="$vuetify.theme.dark"
            class="mb-4"
            height="50"
            src="@/assets/images/logo/logo-light.png"
            alt=""
          />
          <img
            v-else
            class="mb-4"
            height="50"
            src="@/assets/images/logo/logo-dark.png"
            alt=""
          />
          <template v-if="loading && !error">
            <v-alert
              border="left"
              class="text-left"
              text
              icon="mdi-information-outline"
              type="info"
            >
              Verificando ingresso, por favor aguarde
            </v-alert>
          </template>
          <template v-else>
            <v-alert
              border="left"
              class="text-left"
              text
              icon="mdi-alert-circle-outline"
              type="error"
            >
              {{ error }}
            </v-alert>
            <v-btn
              color="secondary"
              class="mt-4"
              block
              :to="{
                name: 'sign-in',
              }"
            >
              Voltar
            </v-btn>
          </template>
        </v-card-text>
      </base-card>
      <div v-if="ticket">
        <v-card class="rounded-xl">
          <v-img
            class="rounded-top-lg"
            :src="ticket.TicketBlock.TicketGroup.Party.cover"
            :aspect-ratio="16 / 9"
          />
          <v-card-text>
            <div class="d-flex gap-2 mb-1 justify-space-between align-center">
              <h5 class="mb-0">
                {{ ticket.TicketBlock.TicketGroup.Party.name }}
              </h5>
              <v-chip label color="success" x-small>Válido</v-chip>
            </div>
            <div class="d-flex gap-2 justify-space-between align-center">
              <h6 class="mb-0">{{ ticket.TicketBlock.TicketGroup.name }}</h6>
              <h6 class="mb-0">{{ ticket.TicketBlock.name }}</h6>
            </div>
            <v-divider class="my-3" />
            <template v-if="ticket.Owner?.name">
              <h6>Participante</h6>
              <div class="d-flex gap-2 align-center mb-2">
                <v-avatar color="primary" size="36">
                  <v-icon>mdi-account</v-icon>
                </v-avatar>
                <b v-if="!ticket.TicketShare[0]">
                  {{ ticket.Owner?.name }}
                </b>
                <div v-else>
                  <b>{{ ticket.TicketShare[0].name }}</b>
                  <small class="d-block"
                    >Compartilhado por {{ ticket.Owner?.name }}</small
                  >
                </div>
              </div>
            </template>
            <v-alert
              v-if="ticket._count.TicketShare > 0"
              type="warning"
              text
              dense
            >
              Esse ingresso foi compartilhado
              {{ ticket._count.TicketShare }} vez{{
                ticket._count.TicketShare > 1 ? "es" : ""
              }}
            </v-alert>
            <v-alert color="warning" text class="mb-0">
              Esse convite é pessoal e intransferível. Não poderá ser utilizado
              por outra pessoa.
            </v-alert>

            <p class="text-center text-caption mb-0 mt-3">
              Ficou com dúvidas? Entre em contato com nosso
              <a
                @click="handleWhatsAppClick"
                :disabled="loadingWhatsapp"
                style="cursor: pointer"
              >
                <v-progress-circular
                  v-if="loadingWhatsapp"
                  size="12"
                  width="2"
                  color="primary"
                  class="mx-4"
                  indeterminate
                />
                <span v-else>suporte</span> </a
              >.
            </p>
          </v-card-text>
        </v-card>
        <v-btn block href="/" text class="mt-2" color="white">
          ir para o app
        </v-btn>
      </div>
    </div>
    <re-captcha
      ref="recaptcha"
      auto-run
      @error="recaptchaError"
      @close="recaptchaError"
      @success="readToken"
    ></re-captcha>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import VERIFY from "@/services/verify";
import RECORDER_SERVICE from "@/services/support/recorder";
import ReCaptcha from "@/components/global/ReCaptcha";

export default {
  name: "VerifyTicket",
  metaInfo: {
    title: "Verificar Ingresso",
  },
  data() {
    return {
      show: false,
      loading: true,
      error: false,
      innerLoading: false,
      innerError: false,
      ticket: null,
      instance: null,
      whatsappUrl: null,
      loadingWhatsapp: false,
    };
  },
  methods: {
    recaptchaError() {
      this.loading = false;
      this.innerLoading = false;
      this.error =
        "Ocorreu ao validar o recaptcha, atualize a página e tente novamente.";
    },

    async readToken(recaptcha) {
      try {
        let id = this.$route.params.id;
        let share = this.$route.query.share;
        let { ticket } = await VERIFY.ticket(id, { share }, recaptcha);
        this.loading = false;
        this.innerLoading = false;
        this.ticket = ticket;
      } catch (e) {
        this.loading = false;
        this.error = e.message;
      }
    },
    async fetchInstance() {
      this.loadingWhatsapp = true;
      try {
        const response = await RECORDER_SERVICE.getInstanceById();
        this.instance = response.data[0];
        this.whatsappUrl = `//wa.me/${this.instance.phone}`;
        window.open(this.whatsappUrl, "_blank");
      } catch (error) {
        console.error("Erro ao buscar instância:", error);
      } finally {
        this.loadingWhatsapp = false;
      }
    },
    handleWhatsAppClick() {
      if (!this.whatsappUrl) {
        this.fetchInstance();
      } else {
        window.open(this.whatsappUrl, "_blank");
      }
    },
  },
  computed: {
    ...mapGetters("app", ["tickets"]),
  },
  mounted() {
    let id = this.$route.params.id;
    if (!id) {
      this.loading = false;
      this.error =
        "Você precisa acessar essa página a partir do link enviado para seu WhatsApp. Não recebeu o link? Clique em voltar e tente novamente.";
    }
    if (this.tickets && this.tickets.length) {
      const ticket = this.tickets.find((t) => t.code == id);
      if (ticket)
        return this.$router.replace({
          name: "app.ticket.details",
          params: { id: ticket.id },
        });
    }
  },
  components: {
    ReCaptcha,
  },
};
</script>
<style lang="scss" scoped>
.page-wrap {
  background: radial-gradient(
      circle at 50% 50%,
      rgba(0, 0, 0, 50%) 0%,
      rgba(0, 0, 0, 90%) 90vw
    ),
    url(/img/logo/auth-background.png), black;
  display: flex;
  background-size: cover;
  background-position: center;
  align-items: center;
  padding: 40px 1rem;
  height: 100%;
  min-height: 100vh;
}
.session-form-hold {
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
}
</style>
